import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { NotificationListResponse } from 'core/layouts/main/models/notificationModel';

export const onGetNotifications = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<NotificationListResponse>>('dashboard/notifications', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetNotificationsCount = async () => {
	try {
		const response = await axios.get<JsonResponse<{ unread_count: number }>>(`dashboard/notifications/unread-count`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onMakrkNotificationsAsRead = async (notification_id: string) => {
	try {
		const response = await axios.post(`dashboard/notifications/${notification_id}/mark-as-read`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onMakrkAllNotificationsAsRead = async () => {
	try {
		const response = await axios.post(`dashboard/notifications/mark-all-as-read`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
